module.exports = __webpack_public_path__ + "img/1-13.5c6a1f4b.jpg";